import { createSlice } from "@reduxjs/toolkit";
//import { sampleMenu } from "../../Entities/RestaurantMenu";
const initialState = {
  restaurantInfo : {},
  //categories : sampleMenu.data.categories,
  //menu_items : sampleMenu.data.menu_items,
  status: "idle",  
  error: null,
};
const restaurantSlice = createSlice({
  name: "restaurant",
  initialState,
  reducers: {
    setRestaurant: (state, action) => {
      const { restaurantInfo } = action.payload;
      state.restaurantInfo = restaurantInfo;
      //state.categories = categories;
      //state.menu_items = menu_items;
      state.status = "succeeded";
      state.error = null;
    },
    setError(state, action) {
    state.error = action.payload;
    state.status = "failed";
  },
    clearRestaurant: (state) => {
      state.restaurantInfo = null;
      //state.categories = [];
      //state.menu_items = [];
      state.status = "idle";
      state.error = null;
    },
    updateRestaurantInfo: (state, action) => {
      const { id, name } = action.payload;
      if (!state.restaurantInfo) return;
      for (const rest of state.restaurantInfo) {
        const item = rest.items.find((i) => i.id === id);
        if (item) {
          item.name = name;
          break;
        }
      }
    },
  },
});

export const { setRestaurant,setError,clearRestaurant,updateRestaurantInfo } = restaurantSlice.actions;
export default restaurantSlice.reducer;